"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var setFlexPaneVisibility_1 = require("../actions/setFlexPaneVisibility");
var store_1 = require("../store/store");
var mobx_react_1 = require("mobx-react");
var Panel_1 = require("office-ui-fabric-react/lib/Panel");
var owa_resize_event_1 = require("owa-resize-event");
var React = require("react");
var ReactDOM = require("react-dom");
var styles = require('./FlexPane.scss');
var classNames = require('classnames/bind').bind(styles);
/**
 * This component is broken out so that it will re-render if headerText is a () => string,
 * and the observable string changes.
 * Otherwise, the Fabric Panel isn't observable, and the OWA FlexPane.render() method doesn't
 * directly dereference header text, so it would never rerender.
 */
var FlexPaneHeader = mobx_react_1.observer(function (props) {
    var headerText = props.headerText &&
        (typeof props.headerText === 'string' ? props.headerText : props.headerText());
    return (React.createElement("span", { className: styles.headerText, role: "heading", "aria-level": 2 }, headerText));
});
var FlexPane = /** @class */ (function (_super) {
    tslib_1.__extends(FlexPane, _super);
    function FlexPane() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onFlexPaneDismiss = function () {
            setFlexPaneVisibility_1.default(false);
            // check if panel closing has been initiated by explicit action
            if (!isExternalHide) {
                activePaneCount--;
            }
            // reset the flag
            isExternalHide = false;
            if (_this.props.onDismiss) {
                _this.props.onDismiss();
            }
        };
        _this.onRenderHeader = function (props, defaultRender) {
            return (React.createElement("div", { className: styles.header },
                React.createElement(FlexPaneHeader, tslib_1.__assign({}, _this.props)),
                defaultRender(props)));
        };
        return _this;
    }
    FlexPane.prototype.render = function () {
        return (React.createElement(Panel_1.Panel, { isOpen: store_1.default.isShown, isBlocking: this.props.overlayOnSmallWidth, forceFocusInsideTrap: false, onDismiss: this.onFlexPaneDismiss.bind(this), headerClassName: this.props.headerClassName, className: classNames(styles.flexPane, {
                overlay: this.props.overlayOnSmallWidth,
            }), isLightDismiss: true, onRenderNavigation: this.onRenderHeader }, this.props.children));
    };
    FlexPane.prototype.componentDidMount = function () {
        this.previousIsShown = store_1.default.isShown;
        if (this.previousIsShown) {
            owa_resize_event_1.lazyTriggerResizeEvent.importAndExecute();
        }
    };
    FlexPane.prototype.componentDidUpdate = function () {
        if (this.previousIsShown != store_1.default.isShown) {
            owa_resize_event_1.lazyTriggerResizeEvent.importAndExecute();
            this.previousIsShown = store_1.default.isShown;
        }
    };
    FlexPane = tslib_1.__decorate([
        mobx_react_1.observer
    ], FlexPane);
    return FlexPane;
}(React.Component));
var flexPaneContainer;
/*
    'activePaneCount' counts how many times flex pane has been opened.
    These is needed when open and hide requests can go out of order.
    'isExternalHide' indicates whether hide was initiated throught action.
    This is used to prevent double counting the hides.
*/
var activePaneCount = 0;
var isExternalHide = false;
function mountAndShowFlexPane(content, options) {
    if (!flexPaneContainer) {
        flexPaneContainer = document.createElement('div');
        document.body.appendChild(flexPaneContainer);
    }
    var props = tslib_1.__assign({
        overlayOnSmallWidth: true,
    }, options);
    ReactDOM.render(React.createElement(FlexPane, tslib_1.__assign({}, props), content), flexPaneContainer);
    setFlexPaneVisibility_1.default(true, props.overlayOnSmallWidth);
    activePaneCount++;
}
exports.mountAndShowFlexPane = mountAndShowFlexPane;
function hideFlexPane() {
    isExternalHide = true;
    if (activePaneCount > 1) {
        activePaneCount--;
    }
    else {
        setFlexPaneVisibility_1.default(false);
        activePaneCount = 0;
    }
}
exports.hideFlexPane = hideFlexPane;
//# sourceMappingURL=FlexPane.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-flex-pane/lib/components/FlexPane.js
// module id = 4522
// module chunks = 98